import { Helmet } from "react-helmet-async"

export type IMetaData = {
  title?: string
  description?: string
  /** Absolute URL to a social share image (Open Graph / Twitter cards). */
  imageUrl?: string
  /** Canonical URL for this page. */
  canonicalUrl?: string
  /** Structured data (JSON-LD) injected as one or more <script type="application/ld+json"> tags. */
  jsonLd?: Record<string, unknown> | Record<string, unknown>[]
}

export const MetaData = ({ title, description, imageUrl, canonicalUrl, jsonLd }: IMetaData) => {
  const fullTitle = `${title ? title + " |" : ""} Scale`
  const jsonLdBlocks = jsonLd == null ? [] : Array.isArray(jsonLd) ? jsonLd : [jsonLd]

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description != null ? <meta name="description" content={description} /> : null}
      {canonicalUrl != null ? <link rel="canonical" href={canonicalUrl} /> : null}

      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      {description != null ? <meta property="og:description" content={description} /> : null}
      {canonicalUrl != null ? <meta property="og:url" content={canonicalUrl} /> : null}
      {imageUrl != null ? <meta property="og:image" content={imageUrl} /> : null}

      <meta name="twitter:card" content={imageUrl != null ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={fullTitle} />
      {description != null ? <meta name="twitter:description" content={description} /> : null}
      {imageUrl != null ? <meta name="twitter:image" content={imageUrl} /> : null}

      {jsonLdBlocks.map((block, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(block)}
        </script>
      ))}
    </Helmet>
  )
}
